import { useEntityAPI } from '../../../redux/entity-api.hook';
import { testTypeAPI } from '../redux/test-types.slice';

export function useTestTypes() {
  return useEntityAPI(testTypeAPI);
}
